(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.searchButton = this.querySelector('.search-button');
      this.cartButton = document.querySelector('#cart-item-count');
      this.mobileMenuOpener = document.querySelector('.mobile-menu-opener');
      this.parentMenus = document.querySelectorAll('.main-menu .parent-menu');
      this.parentMenusLinks = document.querySelectorAll('.main-menu .parent-menu > a');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onMobileMenuHandler = this.onMobileMenu.bind(this);
      
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.searchButton.addEventListener('click', this.onSearch);
      this.mobileMenuOpener.addEventListener('click', this.onMobileMenuHandler);

      
      this.parentMenus.forEach(menu => {
        menu.addEventListener('mouseenter', this.onSubmenuEnter);
        menu.addEventListener('mouseleave', this.onSubmenuLeave);
      });

      this.parentMenusLinks.forEach(menu => {
        menu.addEventListener('click', this.onSubmenuClick);
      }); 

      this.createObserver();
    }


    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.searchButton.removeEventListener('click', this.onSearch);
      this.mobileMenuOpener.removeEventListener('click', this.onMobileMenuHandler);

      this.parentMenus.forEach(menu => {
        menu.removeEventListener('mouseenter', this.onSubmenuEnter);
        menu.removeEventListener('mouseleave', this.onSubmenuLeave);
      });

      this.parentMenusLinks.forEach(menu => {
        menu.removeEventListener('click', this.onSubmenuClick);
      }); 
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      document.body.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      document.body.classList.add('shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      document.body.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    onSearch() {
      document.body.classList.toggle('search-opened');
    }


    onMobileMenu() {
      document.body.classList.toggle('menu-opened');

      let facets = document.querySelector('menu-drawer.mobile-facets__wrapper > details');
      if (facets) {
        facets.classList.remove('menu-opening');
        facets.removeAttribute('open');
      }
      
    }

    onSubmenuEnter() {
      document.body.classList.add('submenu-opened');
    }

    onSubmenuLeave() {
      document.body.classList.remove('submenu-opened');
    }

    onSubmenuClick(e) {
      if (window.innerWidth > 960) {
        return;
      }
      e.target.setAttribute('avoid', true);
      e.preventDefault();
      e.stopPropagation();

      e.target.parentNode.classList.toggle('opened');

    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  let productTypeLabel = document.querySelector('.mobile-facets__summary.caracterisiticas');
  if (productTypeLabel) {
    productTypeLabel.remove();
  }

  let newSubmenu = document.querySelector('.product-type-submenu');
  let productTypeSubmenu = document.querySelector('.mobile-facets__submenu.caracterisiticas');
  if (productTypeSubmenu) {
    let duplicatedMenu = productTypeSubmenu.cloneNode(true);
    duplicatedMenu.querySelectorAll('input').forEach((input) => {
      input.setAttribute('data-id', input.getAttribute('id'));
      input.removeAttribute('id');
      input.closest('.mobile-facets__label').addEventListener('click', function () {
        input.checked = !input.checked;
      });
    });
    newSubmenu.appendChild(duplicatedMenu);
    productTypeSubmenu.classList.add('hide');
  }

  } catch(e) { console.error(e); }
})();
})();
